module.exports = __webpack_public_path__ + "static/media/alina_batcu.5bd58710.png";